import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/broadcast";

export const GetBroadcastUsers = async (values) => {
  return await axiosInstance(options).get(`${path}/users${objToURL(values)}`);
};

export const SendBroadcast = async (data) => {
  return await axiosInstance(options).post(`${path}/send`, data);
};

export const GetBroadcastHistory = async (values) => {
  return await axiosInstance(options).get(`${path}/history${objToURL(values)}`);
};

export const GetBroadcastDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/details/${id}`);
};
